import { METATAGGER_AUDIT_ACTIONS } from 'ion-experimental/app/metatagger/auditActions';

const actions = {
  ajs_file_built: 'AJS_FILE_BUILT',
  ajs_file_uploaded: 'AJS_FILE_UPLOADED',
  auth_logged_in: 'AUTH_LOGGED_IN',
  auth_logged_out: 'AUTH_LOGGED_OUT',
  consent_category_created: 'CONSENT_CATEGORY_CREATED',
  consent_category_deleted: 'CONSENT_CATEGORY_DELETED',
  consent_category_updated: 'CONSENT_CATEGORY_UPDATED',
  event_name_created: 'EVENT_NAME_CREATED',
  event_name_deleted: 'EVENT_NAME_DELETED',
  event_name_updated: 'EVENT_NAME_UPDATED',
  event_schema_created: 'EVENT_SCHEMA_CREATED',
  event_schema_updated: 'EVENT_SCHEMA_UPDATED',
  event_schema_deleted: 'EVENT_SCHEMA_DELETED',
  integration_added_to_pipeline: 'INTEGRATION_ADDED_TO_PIPELINE',
  integration_created: 'INTEGRATION_CREATED',
  integration_deleted: 'INTEGRATION_DELETED',
  integration_removed_from_pipeline: 'INTEGRATION_REMOVED_FROM_PIPELINE',
  integration_revision_created: 'INTEGRATION_REVISION_CREATED',
  integration_revision_disabled: 'INTEGRATION_REVISION_DISABLED',
  integration_revision_enabled: 'INTEGRATION_REVISION_ENABLED',
  integration_updated: 'INTEGRATION_UPDATED',
  pipeline_created: 'PIPELINE_CREATED',
  pipeline_deleted: 'PIPELINE_DELETED',
  pipeline_deployed: 'PIPELINE_DEPLOYED',
  pipeline_integration_updated: 'PIPELINE_INTEGRATION_UPDATED',
  pipeline_tag_added_to_pipeline: 'PIPELINE_TAG_ADDED_TO_PIPELINE',
  pipeline_tag_created: 'PIPELINE_TAG_CREATED',
  pipeline_tag_deleted: 'PIPELINE_TAG_DELETED',
  pipeline_tag_removed_from_pipeline: 'PIPELINE_TAG_REMOVED_FROM_PIPELINE',
  pipeline_tag_updated: 'PIPELINE_TAG_UPDATED',
  pipeline_updated: 'PIPELINE_UPDATED',
  pipeline_variable_updated: 'PIPELINE_VARIABLE_UPDATED',
  sample_event_created: 'SAMPLE_EVENT_CREATED',
  sample_event_updated: 'SAMPLE_EVENT_UPDATED',
  sample_event_deleted: 'SAMPLE_EVENT_DELETED',
  schema_created: 'SCHEMA_CREATED',
  schema_deleted: 'SCHEMA_DELETED',
  schema_updated: 'SCHEMA_UPDATED',
  schema_library_created: 'SCHEMA_LIBRARY_CREATED',
  schema_library_updated: 'SCHEMA_LIBRARY_UPDATED',
  schema_library_deleted: 'SCHEMA_LIBRARY_DELETED',
  schema_library_published: 'SCHEMA_LIBRARY_PUBLISHED',
  schema_library_added_to_pipeline: 'SCHEMA_LIBRARY_ADDED_TO_PIPELINE',
  schema_library_removed_from_pipeline: 'SCHEMA_LIBRARY_REMOVED_FROM_PIPELINE',
  standalone_sync_file_built: 'STANDALONE_SYNC_FILE_BUILT',
  user_deleted: 'USER_DELETED',
  user_invited: 'USER_INVITED',
  user_role_edited: 'USER_ROLE_EDITED',
  ...METATAGGER_AUDIT_ACTIONS,
};

export default actions;
